// Link-mark operations for TiptapEditor's link dialog. Kept out of the
// component so they can be exercised against a real editor instance.
//
// The important rule: whenever the caret or selection sits on an existing link,
// operate on the link's whole mark range (extendMarkRange), never on the raw
// selection. A bare caret inside a link has an EMPTY selection, so `setLink`
// would insert a second link beside it and `unsetLink` would only clear stored
// marks — both look like "nothing happened" to the user.

/** What the link dialog should open with for the current selection. */
export function readLinkDialogState(editor) {
  if (!editor) return { url: '', text: '', isEditing: false }

  const { from, to } = editor.state.selection

  return {
    url: editor.getAttributes('link').href || '',
    text: editor.state.doc.textBetween(from, to) || '',
    isEditing: editor.isActive('link'),
  }
}

/** Create the link, or re-point the existing one under the cursor. */
export function applyLinkToEditor(editor, { url, text = '' } = {}) {
  if (!editor || !url) return false

  const chain = editor.chain().focus()

  if (editor.isActive('link')) {
    return chain.extendMarkRange('link').setLink({ href: url }).run()
  }

  if (!editor.state.selection.empty) {
    return chain.setLink({ href: url }).run()
  }

  const label = text || url
  return chain
    .insertContent(`<a href="${url}" target="_blank" rel="noopener noreferrer">${label}</a>`)
    .run()
}

/** Drop the link under the cursor, keeping its text. */
export function removeLinkFromEditor(editor) {
  if (!editor) return false

  return editor.chain().focus().extendMarkRange('link').unsetLink().run()
}
